import { render, staticRenderFns } from "./PlansTabsSection.vue?vue&type=template&id=db6dfece&scoped=true"
import script from "./PlansTabsSection.vue?vue&type=script&lang=js"
export * from "./PlansTabsSection.vue?vue&type=script&lang=js"
import style0 from "./PlansTabsSection.vue?vue&type=style&index=0&id=db6dfece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6dfece",
  null
  
)

export default component.exports